module.exports = __webpack_public_path__ + "static/img/gopay.64e84b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gopay.png
// module id = HygB
// module chunks = 2